import React from 'react'
export var ODHSpread = function (props) {
  var style = props.style,
    _a = props.children,
    children = _a === void 0 ? [] : _a
  // @ts-ignore
  var firstChild = children[0] || 'Provide [0] children'
  // @ts-ignore
  var secondChild = children[1] || 'Provide [1] children'
  return React.createElement(
    'div',
    { className: 'w-full flex flex-row justify-between', style: style },
    React.createElement(React.Fragment, null, firstChild),
    React.createElement(React.Fragment, null, secondChild)
  )
}
//# sourceMappingURL=ODHSpread.js.map
